module.exports = __webpack_public_path__ + "img/data_subdirectory_contents.a6e54823.png";